import styles from './main.module.scss';
import React from 'react';
import {classNames} from '../../support/classnames.ts';

interface OwnProps {
    children?: React.ReactNode;
    className?: string;
}

export function Main({children, className}: OwnProps) {
    return <main className={classNames(className, styles.main)}>{children}</main>;
}
